import { Injectable } from '@angular/core';

export interface ICustomWindow extends Window {
  MP_DEVICE_SESSION_ID: string;
}

function getWindow (): any {
  return window;
}

@Injectable()
export class WindowRefService {
  get nativeWindow (): ICustomWindow {
    return getWindow();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/window.service.ts